import tw, { styled } from 'twin.macro';

export const LabelInputWrapper = styled.label`
  ${tw`inline-flex w-full relative font-normal border border-solid border-fieldGray rounded opacity-70`}
  ${({ notInBuilder }) =>
    notInBuilder &&
    `
    border-color: var(--formFieldBorderColor, #DADADA);
    border-radius: var(--formFieldBorderRadius);
    color: var(--formFieldColor, var(--formTextColor));
  `}
`;

export const LabeledButton = styled.div`
  ${tw`text-black p-4 px-3 flex-initial flex-shrink-0 justify-between border-none`}
  background: #e8e8e8;
  min-width: 20px;
  font-family: 'Circular Std' !important;
  font-weight: 100 !important;
  color: #777;
  border-radius: inherit;
  text-align: center;

  ${({ notInBuilder }) =>
    notInBuilder &&
    `
    border-radius: var(--formFieldBorderRadius);
    font-family: var(--formFontType) !important;
    background-color: var(--btn-bag, #e8e8e8);
    color: var(--btn-color, #777);
  `}

  ${({ right }) =>
    right &&
    `
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    border-left: none;
  `}

  ${({ left }) =>
    left &&
    `
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    border-right: none;
  `}
`;
